export function getItemDefinitionKey(itemPlan) {
    return itemPlan.itemDefinitionKey;
}
export function getDataOrigin(itemPlan) {
    return itemPlan.dataOrigin;
}
export function getItemName(itemPlan) {
    return itemPlan.itemName;
}
export function getChoice(itemPlan) {
    return itemPlan.choice;
}
export function getOriginDefinitionKey(itemPlan) {
    return itemPlan.originDefinitionKey;
}
export function getDescription(itemPlan) {
    return itemPlan.description;
}
export function getItem(itemPlan) {
    return itemPlan.item;
}
